import request from '@/util/request'

export function deviceGroupList(params) {
    return request({
        url: '/api/v1/delivery/device/group/list',
        method: 'get',
        params
    })
}

export function deviceGroupUnion(params) {
    return request({
        url: '/api/v1/delivery/device/group/union',
        method: 'get',
        params
    })
}

export function deviceGroupDelete(params) {
    return request({
        url: '/api/v1/delivery/device/group/delete',
        method: 'get',
        params
    })
}
